import ObjectiveService from 'src/modules/objective/objectiveService';
import selectors from 'src/modules/objective/list/objectiveListSelectors';
import { i18n } from 'src/i18n';
import exporterFields from 'src/modules/objective/list/objectiveListExporterFields';
import Errors from 'src/modules/shared/error/errors';
import Exporter from 'src/modules/shared/exporter/exporter';
import issuesListActions from 'src/modules/issues/list/issuesListActions';
import Message from 'src/view/shared/message';

const prefix = 'OBJECTIVE_LIST';

// Only the most recent fetch may update the list. Navigating from a company page
// to the list page starts a filtered and an unfiltered fetch, and without this
// whichever response arrived last won.
let latestFetchId = 0;

const objectiveListActions = {
  FETCH_STARTED: `${prefix}_FETCH_STARTED`,
  FETCH_SUCCESS: `${prefix}_FETCH_SUCCESS`,
  FETCH_ERROR: `${prefix}_FETCH_ERROR`,

  RESETED: `${prefix}_RESETED`,
  SELECTEDS_CHANGED: `${prefix}_SELECTEDS_CHANGED`,

  PAGINATION_CHANGED: `${prefix}_PAGINATION_CHANGED`,
  SORTER_CHANGED: `${prefix}_SORTER_CHANGED`,

  EXPORT_STARTED: `${prefix}_EXPORT_STARTED`,
  EXPORT_SUCCESS: `${prefix}_EXPORT_SUCCESS`,
  EXPORT_ERROR: `${prefix}_EXPORT_ERROR`,

  doChangeSelected(payload) {
    return {
      type: objectiveListActions.SELECTEDS_CHANGED,
      payload,
    };
  },

  doReset: () => async (dispatch) => {
    dispatch({
      type: objectiveListActions.RESETED,
    });

    dispatch(objectiveListActions.doFetch());
  },

  doExport: () => async (dispatch, getState) => {
    try {
      if (!exporterFields || !exporterFields.length) {
        throw new Error('exporterFields is required');
      }

      dispatch({
        type: objectiveListActions.EXPORT_STARTED,
      });

      const filter = selectors.selectFilter(getState());
      const response = await ObjectiveService.list(
        filter,
        selectors.selectOrderBy(getState()),
        null,
        null,
      );

      new Exporter(
        exporterFields,
        i18n('entities.objective.exporterFileName'),
      ).transformAndExportAsExcelFile(response.rows);

      dispatch({
        type: objectiveListActions.EXPORT_SUCCESS,
      });

      Message.success(
        i18n('common.exported.success'),
      );
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: objectiveListActions.EXPORT_ERROR,
      });
    }
  },

  doChangePaginationAndSort: (pagination, sorter) => async (
    dispatch,
    getState,
  ) => {
    dispatch({
      type: objectiveListActions.PAGINATION_CHANGED,
      payload: pagination,
    });

    dispatch({
      type: objectiveListActions.SORTER_CHANGED,
      payload: sorter,
    });

    dispatch(objectiveListActions.doFetchCurrentFilter());
  },

  doFetchCurrentFilter: () => async (
    dispatch,
    getState,
  ) => {
    const filter = selectors.selectFilter(getState());
    const rawFilter = selectors.selectRawFilter(getState());
    dispatch(objectiveListActions.doFetch(filter, rawFilter, true));
  },

  doFetch: (filter?, rawFilter?, keepPagination = false) => async (
    dispatch,
    getState,
  ) => {
    const fetchId = ++latestFetchId;

    try {
      dispatch({
        type: objectiveListActions.FETCH_STARTED,
        payload: { filter, rawFilter, keepPagination },
      });

      const response = await ObjectiveService.list(
        filter,
        selectors.selectOrderBy(getState()),
        selectors.selectLimit(getState()),
        selectors.selectOffset(getState()),
      );

      if (fetchId !== latestFetchId) {
        return;
      }

      dispatch({
        type: objectiveListActions.FETCH_SUCCESS,
        payload: {
          rows: response.rows,
          count: response.count,
        },
      });
      dispatch(issuesListActions.doFetchAll());

    } catch (error) {
      if (fetchId !== latestFetchId) {
        return;
      }

      Errors.handle(error);

      dispatch({
        type: objectiveListActions.FETCH_ERROR,
      });
    }
  },
};

export default objectiveListActions;
